export default "__VITE_ASSET__gpuAdC24__"